<template>
  <div class="page-top-container">

    <div class="background-container">
      <div class="logo" :class="{ scrolled: isScrolled }">
        <div class="logo-icon"><img src="../assets/PR_logo.png" alt="DiOrion Logo" class="logo-img"></div>
        <div class="logo-text">DiOrion</div>
      </div>

      <div class="content-wrapper">
        <h2>AI-powered One-stop Platform for Innovative Drug Discovery</h2>
        <p>
          Driven by the dual engines of MLLM and AIDD, leveraging cutting-edge AI technologies including MLLM, diffusion models and reinforcement learning, this covers the entire workflow from target selection to PCC nomination, enhancing the efficiency and success rate of drug discovery and development.
        </p>
      </div>
    </div>

    <!-- 2. 按钮区：与 background-container 同级，单独拎出 -->
    <div class="btn-actions" :class="{ scrolled: isScrolled }">
      <button class="header-btn login-btn" @click="handleOpenLoginModal">
        Login
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isScrolled: false // 滚动状态仍控制 Logo 和按钮
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50; // 滚动逻辑不变
    },
    handleOpenLoginModal() {
      this.$emit('open-login-modal');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  }
};
</script>

<style scoped>
/* 外层容器：relative 定位，作为按钮的定位参考（避免按钮相对于视口偏移） */
.page-top-container {
  position: relative;
  width: 100%;
}

/* 背景容器：保留原有样式，无需负 z-index（按钮已脱离其内部） */
.background-container {
  background-image: url('../assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  min-height: 400px;
  position: relative; /* 仅控制内部 Logo 和文字 */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: white;
  background-color: rgba(10, 25, 47, 0.7);
  background-blend-mode: overlay;
  z-index: -2;
}

/* 1. Logo 样式不变（仍在背景容器内） */
.logo {
  position: absolute;
  top: 1.5rem;
  left: 2.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.logo.scrolled {
  top: 1rem;
}

.logo-icon .logo-img {
  width: 50px;
  height: auto;
}

.logo-text {
  font-size: 3rem;
  font-weight: 600;
  color: white;
}

/* 2. 按钮区：与背景容器同级，置于顶层 */
.btn-actions {
  position: absolute; /* 相对于外层 page-top-container 定位 */
  top: 1.5rem; /* 与原位置一致 */
  right: 1rem; /* 与原位置一致 */
  z-index: 10; /* 高于背景容器（默认层级），确保顶层显示 */
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
  /* 确保按钮不受其他元素遮挡，显式允许点击 */
  pointer-events: auto;
}

/* 滚动后按钮位置调整（逻辑不变） */
.btn-actions.scrolled {
  top: 1rem;
}

/* 按钮样式不变 */
.header-btn {
  padding: 0.45rem 1.2rem;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  margin-right: 60px;
}

.login-btn {
  background: transparent;
  border: 1px solid #64ffda;
  color: #64ffda;
}

.login-btn:hover {
  background: rgba(100, 255, 218, 0.1);
  transform: translateY(-1px);
}

.register-btn {
  background: #64ffda;
  color: #0a192f;
}

.register-btn:hover {
  background: #4cc9aa;
  transform: translateY(-1px);
}

/* 3. 文字内容区样式不变 */
.content-wrapper {
  padding-left: 8%;
  max-width: 45%;
}

.content-wrapper h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
}

.content-wrapper p {
  font-size: 1.2rem;
  line-height: 1.6;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

/* 4. 响应式适配：按钮和 Logo 样式不变 */
@media (max-width: 768px) {
  .logo {
    top: 1rem;
    left: 1.2rem;
    gap: 0.6rem;
  }

  .logo-icon .logo-img {
    width: 32px;
  }

  .logo-text {
    font-size: 1.3rem;
  }

  .btn-actions {
    top: 1rem;
    right: 1.2rem;
    gap: 0.8rem;
  }

  .header-btn {
    padding: 0.4rem 0.9rem;
    font-size: 0.85rem;
  }

  .content-wrapper {
    padding-left: 5%;
    max-width: 70%;
  }

  .content-wrapper h2 {
    font-size: 2rem;
  }

  .content-wrapper p {
    font-size: 1rem;
  }
}
</style>